import styled from '@emotion/styled';
import {FormControlLabel, Switch} from '@mui/material';
import React from 'react';

export type ESwitchProps = {
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
  label?: string;
  testId?: string;
};
export function ESwitch({
  checked,
  onChange,
  disabled,
  ariaLabel,
  label,
  testId,
}: ESwitchProps): React.ReactElement {
  const switchElement = (
    <StyledSwitch
      checked={checked}
      disabled={disabled}
      slotProps={{
        input: {
          role: 'switch',
          'aria-label': ariaLabel,
          'data-testid': testId ? `ESwitch-${testId}` : undefined,
        } as React.InputHTMLAttributes<HTMLInputElement>,
      }}
      disableRipple
      onChange={onChange}
    />
  );

  return (
    <>
      {label ? (
        <StyledFormControlLabel control={switchElement} label={label} />
      ) : (
        switchElement
      )}
    </>
  );
}

const StyledFormControlLabel = styled(FormControlLabel)`
  width: fit-content;
  margin-left: 0;
  & .MuiFormControlLabel-label {
    font-weight: var(--font-weight-thin);
    color: var(--color-core-black);
    margin-left: var(--gutter-little);
  }
`;

const StyledSwitch = styled(Switch)`
  border: var(--focus-border-width) solid transparent;
  border-radius: 20px;
  width: 28px;
  height: 16px;
  padding: 0;
  box-sizing: content-box;

  &:focus-within {
    border-color: var(--color-core-keyboardfocus);
  }

  & .MuiSwitch-switchBase {
    padding: var(--gutter-very-tiny);

    &.Mui-checked {
      transform: translateX(12px);
      color: var(--color-core-white);

      & + .MuiSwitch-track {
        opacity: 1;
        background-color: var(--color-state-active);
        transition: background-color 0.3s ease 0s;
      }
    }
  }

  & .MuiSwitch-thumb {
    width: var(--icon-small-dimension);
    height: var(--icon-small-dimension);
  }

  & .MuiSwitch-track {
    background-color: var(--color-core-grey);
    opacity: 1;
  }
`;
